import { getUser, reviveDate } from '@/utils';
import { platformApiRootUrl } from '@/utils/config';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { useEffect, useState } from 'react';

export function useTelematicsBoxPollStream(imei) {
  const [polls, setPolls] = useState([]);
  const user = getUser();

  useEffect(() => {
    const ctrl = new AbortController();

    fetchEventSource(`${platformApiRootUrl}/sse/telematics-box-polls/${imei}`, {
      headers: {
        authorization: `Bearer ${user?.access_token}`,
      },
      signal: ctrl.signal,
      onmessage(msg) {
        console.log('Received message:', msg);

        if (msg.event === 'insert') {
          const poll = JSON.parse(msg.data, reviveDate);
          setPolls((prevPolls) => [poll, ...prevPolls]);
        }
      },
    });

    return () => {
      ctrl.abort();
    };
  }, [imei, user?.access_token]);

  return polls;
}
